import styled from '@emotion/styled';

import { CONTENT_RIGHT_LEFT_PADDING } from '@hotjar/heatmaps';
import { tokens } from '@hotjar/hotsauce';
import type { Site } from '@hotjar/site';

import { StatusBarActions } from './StatusBarActions';

const StyledStatusBar = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% + ${CONTENT_RIGHT_LEFT_PADDING});
  padding: ${tokens.spacer.x0pt5} ${CONTENT_RIGHT_LEFT_PADDING};
  border-color: ${tokens.color.ui_border};
  border-width: 1px 0px 1px 0px;
  border-style: solid;
  ${tokens.text('body2')};
`;

/**
 * Render a heatmap status bar with page view count and screenshot information.
 * This component shows a popover when the screenshot info is hovered and allows
 * the user to start the retake process.
 *
 * FIXME: fix the props description
 * @param lastScreenshotTimestamp: the last time the heatmap screenshot was taken (the recording date used in generating the heatmap) in epoch
 * @param onRetakeScreenshotClicked: a callback function to start the retake screenshot flow
 * @param highlights: properties related to highlights feature
 * @param filters: JSON object with current filters
 * @param count: The count of clicks or taps of the heatmap
 * @param dataType: The heatmap data type
 */
interface StatusBarProps {
  highlights: {
    activate: () => void;
    deactivate: () => void;
    isActive: boolean;
  };
  onDownloadImage: () => void;
  onDownloadData: () => void;
  currentSite: Site | undefined;
  filtersApplied: boolean;
}

export const StatusBar = ({
  highlights,
  onDownloadImage,
  onDownloadData,
  currentSite,
  filtersApplied,
}: StatusBarProps): JSX.Element => {
  return (
    <StyledStatusBar>
      <StatusBarActions
        filtersApplied={filtersApplied}
        highlights={highlights}
        site={currentSite}
        onDownloadData={onDownloadData}
        onDownloadImage={onDownloadImage}
      />
    </StyledStatusBar>
  );
};
